var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-taglist",
        { attrs: { id: "highlight-simulation" } },
        [
          _c(
            "b-tag",
            { attrs: { type: "is-light is-rounded", size: "is-medium" } },
            [
              _vm._v(" Crédito imóbiliario: "),
              _c(
                "span",
                {
                  staticClass: "has-text-primary",
                  attrs: { "data-cy": "highlight-credito-imobiliario" },
                },
                [_vm._v(_vm._s(_vm.formatNumberByCountry(_vm.financingAmount)))]
              ),
            ]
          ),
          _c(
            "b-tag",
            { attrs: { type: "is-light is-rounded", size: "is-medium" } },
            [
              _vm._v(" Primeira parcela de: "),
              _c(
                "span",
                {
                  staticClass: "has-text-primary",
                  attrs: { "data-cy": "highlight-primera-parcela" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.formatNumberByCountry(_vm.creditFee)) + " + IPCA"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "button tag is-light is-rounded is-medium",
              attrs: { "data-cy": "highlight-data" },
              on: {
                click: function ($event) {
                  _vm.showModal = true
                },
              },
            },
            [_vm._v(" + ")]
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          staticClass: "modal-template",
          attrs: {
            "destroy-on-hide": false,
            "aria-role": "dialog",
            "aria-label": "Simulation results",
            "close-button-aria-label": "Cerrar",
            width: 800,
          },
          model: {
            value: _vm.showModal,
            callback: function ($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal",
          },
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c(
              "header",
              { staticClass: "modal-card-head background-top-modal box" },
              [
                _c("p", { staticClass: "title pl-4 has-text-white" }, [
                  _vm._v("Sua simulação"),
                ]),
              ]
            ),
            _c("section", { staticClass: "modal-card-body" }, [
              _c("div", { staticClass: "columns custom-columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-three-fifths result-content" },
                  [
                    _c("div", { staticClass: "card p-5" }, [
                      _c("div", { staticClass: "pt-5 pl-5 pr-5 pb-2" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" Valor solicitado: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: { id: "amountRequestedByClient" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumberByCountry(
                                        _vm.amountRequestedByClient || 0,
                                        true,
                                        0
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" Última parcela: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: { id: "monthlyTotal" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumberByCountry(
                                        _vm.monthlyTotal,
                                        true,
                                        0
                                      )
                                    ) +
                                    " + IPCA "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" CET: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: { id: "annualPercentageRate" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumberByCountry(
                                        _vm.annualPercentageRate,
                                        false,
                                        2
                                      )
                                    ) +
                                    " % + IPCA "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" Taxa de juros mensal: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: {
                                  id: "offer-response-amount-requested-by-client",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatNumberByCountry(
                                        _vm.monthlyInterestRate,
                                        false,
                                        2
                                      )
                                    ) +
                                    " % + IPCA "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" Tipo de amortização: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: {
                                  id: "offer-response-amount-requested-by-client",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.amortizationMethod === "GERMAN"
                                        ? "SAC"
                                        : "PRICE"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "title is-size-6 is-size-7-mobile divider",
                          },
                          [
                            _vm._v(" Prazo: "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "is-pulled-right has-text-weight-light has-text-primary",
                                attrs: {
                                  id: "offer-response-amount-requested-by-client",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.numberOfMonths) + " meses "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "has-text-centered" }, [
                    _c("div", { staticClass: "dest is-primary" }, [
                      _c(
                        "small",
                        { staticClass: "is-size-7 is-size-7-mobile divider" },
                        [_vm._v(" Valor financiado: ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "is-size-3 is-block has-text-weight-light has-text-primary",
                          staticStyle: { "line-height": "1" },
                          attrs: { id: "offer-response-financing-amount" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatNumberByCountry(_vm.financingAmount)
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("p", { staticClass: "is-size-7 is-size-7-mobile" }, [
                        _vm._v(" Primeira parcela: "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "has-text-weight-light has-text-primary",
                            attrs: { id: "offer-response-credit-fee" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumberByCountry(_vm.creditFee)
                                ) +
                                " "
                            ),
                            !!_vm.ipcaValue
                              ? _c("span", [_vm._v(_vm._s(_vm.$t("ipca")))])
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }